/* 🤖 this file was generated by svg-to-ts */
export const matIconSouth: {
  name: 'south';
  data: string;
} = {
  name: 'south',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m19 15-1.41-1.41L13 18.17V2h-2v16.17l-4.59-4.59L5 15l7 7 7-7z"/></svg>`
};
